import React, { useState } from 'react'
import { TextField, Toolbar, Typography, Button } from '@mui/material';
import { getUserFullName } from 'app/utils/appHelpers';

function UserParticipantDataTableToolbar({ pageTitle, data2, setData, componentType, setPreviousUserButtonClick, setTitleSortingStatus, setHighlightQuery }) {


    const [searchText, setSearchText] = useState("");

    const handleChangeSearchText = (text) => {
        if (text !== "") {

            let search_filtered_data = "";
            if (componentType === "user" || componentType === "participant") {
                search_filtered_data = text === '' ?
                    data2 : data2.filter(item => getUserFullName(item.user).toLocaleLowerCase().includes(text.toLocaleLowerCase()))

            } else {
                search_filtered_data = text === '' ?
                    data2 : data2.filter(item => getUserFullName(item).toLocaleLowerCase().includes(text.toLocaleLowerCase()))

            }

            setSearchText(text);
            setHighlightQuery(text);
            setData(search_filtered_data);

        } else {
            setSearchText(text);
            setHighlightQuery(text);
            setData(data2);
        }
    };


    return (
        <Toolbar

            sx={{
                justifyContent: 'flex-end',
                background: '#e1e1e1',
                maxHeight: '10px !important',

            }}

        >
            <Typography variant="h6" component="h1" sx={{ flexGrow: 1 }}>   {pageTitle}
            </Typography>

            <div>

                <TextField

                    id="searchText1xe"
                    value={searchText}
                    onChange={(e) => handleChangeSearchText(e.target.value)}
                    margin="dense"
                    label={"Arama Yap"}
                    className="mr-4"
                    size="small"
                    style={{ width: "200px", background: 'white', float: 'right' }}
                    placeholder={'Bilgi'}
                />

                {
                    componentType && componentType === "user" ?
                        <Button size="small" variant="outlined" sx={{ marginTop: '14px', marginRight: '8px' }}
                            onClick={() => setPreviousUserButtonClick(true)}

                        >Önceki Üyeleri Getir</Button> : ""
                }
                {
                    componentType && componentType === "participant" ?
                        <Button size="small" variant="outlined" sx={{ marginTop: '14px', marginRight: '8px' }}
                            onClick={() => setPreviousUserButtonClick(true)}

                        >Önceki Katılımcıları Getir</Button> : ""
                }
                {
                    componentType && (componentType === "user" || componentType === "participant") ?
                        <Button size="small" variant="outlined" sx={{ marginTop: '14px', marginRight: '8px' }}
                            onClick={() => setTitleSortingStatus(true)}
                        >Sırala</Button> : ""
                }

            </div>

        </Toolbar>
    );
};

export default UserParticipantDataTableToolbar